const PHONE_NUMBER_REGEX = /^\+\d{3,15}$/;

export default function isPhoneNumber(value) {
  return PHONE_NUMBER_REGEX.test(value);
}
